import React from 'react';

import UserFilter from 'components/Filters/UserFilter';

import { Filter } from '@gogame/filters';

import {
  FILTER_CREATED,
  FILTER_EXPIRATION_PERIOD,
  FILTER_ACTIONS_TYPE,
  FILTER_APPROPVERS,
  FILTER_CREATED_BY,
  FILTER_BUSINESS_ENTITY,
  FILTER_AGREEMENT_TYPES,
  FILTER_OWNERS,
  FILTER_PAYMENT_TERMS,
  FILTER_STATUSES,
  creationPeriodDateRangePresets,
  FILTER_CUSTOMER_COMPANIES,
} from 'scenes/IO/constants';
import {
  loadActions,
  loadApprovers,
  loadAgreementTypes,
  loadCreators,
  loadBusinessEntity,
  loadPaymentTerms,
  loadStatuses,
  loadOwners,
  loadCustomerCompanies,
} from 'scenes/IO/sources/filters';

export const Created = (props) => {
  return (
    <Filter.DateRangePicker
      title={'Added'}
      name={FILTER_CREATED}
      presets={creationPeriodDateRangePresets}
      {...props}
    />
  );
};

export const ExpirationPeriod = (props) => {
  return (
    <Filter.DateRangePicker
      title={'Expiration period'}
      name={FILTER_EXPIRATION_PERIOD}
      {...props}
    />
  );
};

export const ActionsType = (props) => {
  return (
    <Filter.Select
      title={'Show'}
      placeholder={'All'}
      name={FILTER_ACTIONS_TYPE}
      source={loadActions}
      {...props}
    />
  );
};

export const Approvers = (props) => {
  return (
    <Filter.MultiSelect
      title={'Approvers'}
      name={FILTER_APPROPVERS}
      source={loadApprovers}
      placeholder={'All'}
      {...props}
    />
  );
};

export const CreatedBy = (props) => {
  return (
    <UserFilter
      title={'Created By'}
      name={FILTER_CREATED_BY}
      source={loadCreators}
      placeholder={'All'}
      {...props}
    />
  );
};

export const BusinessEntity = (props) => {
  return (
    <Filter.MultiSelect
      title={'Business partners/Affiliates'}
      placeholder={'All'}
      name={FILTER_BUSINESS_ENTITY}
      variant={'outlined'}
      source={loadBusinessEntity}
      {...props}
    />
  );
};

export const AgreementTypes = (props) => {
  return (
    <Filter.MultiSelect
      title={'Agreement Types'}
      name={FILTER_AGREEMENT_TYPES}
      source={loadAgreementTypes}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Owners = (props) => {
  return (
    <UserFilter
      title={'Owners'}
      name={FILTER_OWNERS}
      source={loadOwners}
      withAll={false}
      placeholder={'All'}
      {...props}
    />
  );
};

export const PaymentTerms = (props) => {
  return (
    <Filter.MultiSelect
      title={'Payment Terms'}
      name={FILTER_PAYMENT_TERMS}
      source={loadPaymentTerms}
      placeholder={'All'}
      {...props}
    />
  );
};
export const Statuses = (props) => {
  return (
    <Filter.MultiSelect
      title={'Statuses'}
      name={FILTER_STATUSES}
      source={loadStatuses}
      placeholder={'All'}
      {...props}
    />
  );
};

export const CustomerCompanies = (props) => {
  return (
    <Filter.MultiSelect
      title={'Customer companies'}
      name={FILTER_CUSTOMER_COMPANIES}
      source={loadCustomerCompanies}
      placeholder={'All'}
      {...props}
    />
  );
};
